<template>
  <CommonAnalyticsTable
    :stats="this.stats"
    :total="this.total"
    :currentMonth="currentMonth"
    :statsClickable="true"
    :accessibleStoreIds="accessibleStoreIds"
    :showGrossSalesCount="showGrossSalesCount"
    :showTrainingCompletion="showTrainingCompletion"
    :order="order"
    @row-clicked="handleStoreClick"
    @sort="handleSort"
  />
</template>
<script>
import CommonAnalyticsTable from "@/components/analytics/retail/utils/CommonAnalyticsTable.vue";

export default {
  components: {
    CommonAnalyticsTable,
  },

  emits: ["sort", "store-id-selected"],

  props: [
    "stats",
    "total",
    "currentMonth",
    "accessibleStoreIds",
    "showGrossSalesCount",
    "showTrainingCompletion",
    "order",
  ],

  methods: {
    handleStoreClick(row) {
      this.$emit("store-id-selected", row.id);
    },

    handleSort(column) {
      this.$emit("sort", column);
    },
  },
};
</script>
